import api from '../../../services/api';

/** Reuse the converter's current rate, verified against its persisted currency record. */
export async function fetchInvoiceEuroRate(): Promise<number> {
  const [current, records] = await Promise.all([
    api.get('/exchange-rates'),
    api.get('/exchange-rates/history/EUR'),
  ]);
  const rate = Number(current.data?.rates?.EUR);
  const history = records.data?.history;
  const latest = Array.isArray(history) ? history[history.length - 1] : null;
  if (!Number.isFinite(rate) || rate <= 0 || !latest || Number(latest.rate) !== rate || current.data?.source === 'FALLBACK') {
    throw new Error('INVOICE_CURRENT_FX_UNAVAILABLE');
  }
  return rate;
}
